module.exports = __webpack_public_path__ + "static/media/pointInterestGroup.6a972170.svg";